import React, { Component } from 'react';
import MobileWalletSection from './MobileWalletSection';
import MobileUserBar from './MobileUserBar';
import Navmenu from './navmenu';
import { withRouter } from './withRouter';
import jwt_decode from "jwt-decode";
import instance from "./axios-instance";
import { isMobile } from 'react-device-detect';
import Swal from 'sweetalert2';
import Systems from "./SystemFunction";

class App extends Component {

    constructor(props) {
        super(props)
        this.state = {
            mainsetting: [],
            rewardlist: [],
            activePage: 1,
            checkboxcookie: false,
            isActive: false,
            formData: {},
            errors: {},
            formSubmitted: false,
            loading: true,
            pagecount: 1,
            username: null,
            settingwheel: "",
            settingcheckin: "",
            userid: null,
            phoneNumber: "",
            balance: 0,
            mainacc: null,
            tabselect: 1,
            tabselectsec: 0,
            qrcode: null,
            stateregis: 1,
            checkboxacc: 0,
            products_page_count: 1,
            loginstate: false,
            fullname: null,
            lname: null,
            link: "",
            alert: null,
            depositstate: 0,
            stateforget: 1,
            depositamount: 0,
            stateopterror: "",
            btnisActive: true,
            otpphone: "",
            token: window.localStorage.getItem("token"),
            accnumber: null,
            accnumbertxt: null,
            rankpoint: 0,
            changepassword: false,
            linelink: "",
            errortext: "",
            trueaccount: null,
            datas: null,
            otpphoneforget: "",
            affpercent: 0,
            counter: 300,
            userrecomend: "",
            historylist: [],
            useradvice: [],
            cashoutlist: [],
            tblnextrank: [],
            tblrankall: [],
            maxwithdrawstatus: 0,
            tblprofile: [],
            prodetail: [],
            oldpassword: "",
            linkaff: "",
            webnamex: "",
            inviteSet: "",
            truegiftlink: "",
            proderedeem: [],
            proderedeemlist: [],
            buttoncliam: false,
            limit: null,
            rankpic: "1.jpeg",
            rankname: null,
            rankob: null,
            cashoutSet: [],
            tblPopupMenu1: [],
            tblPopupMenu2: [],
            tblPopupMenu: null,
            termAndCondition: false,
            errorstatus: false,
            /* ── BK8 UI additions ── */
            showMore: false,
            isGuideOpen: false,
            refreshing: false,
            showMemberAction: false,
            isMenuOpen: false,
            menuOpenIndex: 0,
            checkcredit: false,
            firstname: null,
            /* ── Rebate specific ── */
            rebatePeriod: 'daily',       // 'daily' | 'weekly'
            rebateList: [],              // array of {category, turnover, rebateRate, rebateAmount}
            rebateTotalAmount: 0,
            rebateHistory: [],           // array of {date, amount, status}
            claimLoading: false,
            tabRebate: 0,               // 0=เงินคืน, 1=ประวัติ
        }
    }

    checkurl = (e, path) => {
        window.location.href = path;
    }

    recheccredit = async (e) => {
        e.preventDefault();
        this.setState({ checkcredit: true });
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            await instance.post("/api/v1/getcredit", {
                User_id: Username,
                System: Systems,
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                if (res.data.status === 200) {
                    this.setState({ balance: res.data.balance });
                }
            }).catch(() => {});
        }
        this.setState({ checkcredit: false });
    }

    claimRebate = async () => {
        this.setState({ claimLoading: true });
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            await instance.post("/api/v1/claimrebate", {
                User_id: Username,
                System: Systems,
                period: this.state.rebatePeriod,
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                if (res.data.status === 200) {
                    await Swal.fire({
                        title: 'สำเร็จ!',
                        text: 'รับเงินคืนเรียบร้อยแล้ว',
                        icon: 'success',
                        confirmButtonText: 'ตกลง'
                    });
                    this.setState({ rebateTotalAmount: 0 });
                } else {
                    await Swal.fire({
                        title: 'แจ้งเตือน!',
                        text: res.data.message || 'ไม่มียอดเงินคืน',
                        icon: 'warning',
                        confirmButtonText: 'ตกลง'
                    });
                }
            }).catch(() => {
                Swal.fire({ title: 'ผิดพลาด!', text: 'ไม่สามารถรับเงินคืนได้', icon: 'error', confirmButtonText: 'ตกลง' });
            });
        }
        this.setState({ claimLoading: false });
    }

    async componentDidMount() {
        var token = localStorage.getItem('auth_token');
        if (token) {
            try {
                var decoded = jwt_decode(token);
                var Username = decoded.message.playerid;
                this.setState({
                    username: decoded.message.playerid,
                    loginstate: true,
                });

                // ดึง balance จาก checkpoint
                await instance.post("/api/v1/checkpoint", {
                    userid: Username,
                    System: Systems,
                    Function: 'componentDidMount-rebate.js'
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                }).then(async (res) => {
                    if (res.data.status === 200) {
                        localStorage.setItem('auth_token', res.data.token);
                        this.setState({
                            balance: res.data.databalance,
                            fullname: res.data.message.firstname,
                            rankname: res.data.tblrank?.name || 'Normal',
                            rankpoint: res.data.rankpoint || 0,
                            loginstate: true,
                        });
                    } else if (res.data.status === 401) {
                        localStorage.clear();
                        this.props.navigate('/');
                    }
                });

                // ดึงยอดได้เสีย/เงินคืน จาก checkpoint (AffiliateCash)
                await instance.post("/api/v1/checkpoint", {
                    userid: Username,
                    System: Systems,
                    Function: 'rebate-cashout'
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                }).then((res) => {
                    if (res.data.status === 200) {
                        const profile = res.data.message || {};
                        const cashoutSetting = Array.isArray(res.data.tblcashoutsetting) && res.data.tblcashoutsetting.length > 0
                            ? res.data.tblcashoutsetting[0] : {};
                        this.setState({
                            rebateTotalAmount: parseFloat(profile.AffiliateCash || 0),
                            cashoutSet: cashoutSetting,
                            linelink: res.data.linelink || '',
                        });
                    }
                }).catch(() => {});

                // ดึงประวัติเงินคืน
                await instance.get("/api/v1/rewardlist", {
                    params: { Cat_ID: 0, page: 1 }
                }).then((res) => {
                    if (res.data.status === 200) {
                        this.setState({
                            rebateHistory: res.data.message?.products || [],
                        });
                    }
                }).catch(() => {});
            } catch (e) {
                this.props.navigate('/');
            }
        } else {
            this.props.navigate('/');
        }
    }

    renderMobile() {
        const {
            balance, username, linelink, rankname, rankpoint,
            isGuideOpen, showMore, showMemberAction,
            loginstate, isMenuOpen, menuOpenIndex, checkcredit, firstname,
            rebatePeriod, rebateList, rebateTotalAmount, rebateHistory,
            claimLoading, tabRebate,
        } = this.state;

        // Default rebate rate table (shown when no API data)
        const defaultRebateRates = [
            { category: 'กีฬา', icon: 'sports', rate: '0%', color: '#16a34a' },
            { category: 'คาสิโนสด', icon: 'casino', rate: '0%', color: '#7c3aed' },
            { category: 'สล็อต', icon: 'slot', rate: '0%', color: '#f59e0b' },
            { category: 'ยิงปลา', icon: 'fish', rate: '0%', color: '#0ea5e9' },
            { category: 'อีสปอร์ต', icon: 'esport', rate: '0%', color: '#ef4444' },
            { category: 'ล็อตเตอรี่', icon: 'lotto', rate: '0%', color: '#ec4899' },
        ];

        const bkCss = `
            /* ══ PAGE ══ */
            .bk-rebate-page{min-height:100vh;background:#f5f6f8;padding-bottom:80px;font-family:'Prompt','Noto Sans Thai',sans-serif;max-width:100vw;overflow-x:hidden;color:#1a1a1a;}
            /* ติดขอบล่างจอเสมอ (เดิม sticky ลอยกลางจอเพราะเนื้อหาสั้น) */
            .bk-rebate-page .bottom-navbar-container{position:fixed!important;left:0;right:0;bottom:0;width:100%;z-index:200;}

            /* ══ NAVBAR HEADER ══ */
            .mobile-navbar-header{position:sticky;top:0;z-index:150;background:#fff;box-shadow:none!important;border:none!important;border-bottom:none!important;}
            .mobile-nav{display:flex;align-items:center;justify-content:space-between;padding:0 16px;height:56px;width:100%;box-sizing:border-box;border:none!important;box-shadow:none!important;}
            .mobile-nav.header-grey{background:#fff;border:none!important;box-shadow:none!important;}
            .bk-rebate-page header{border:none!important;box-shadow:none!important;}
            .bk-rebate-page header *{border-bottom:none!important;}
            .col-left{display:flex;align-items:center;gap:12px;flex:1;min-width:0;}
            .col-right{display:flex;align-items:center;flex-shrink:0;}
            .menu-icon.beta-back{width:22px;height:22px;flex-shrink:0;}
            p.page-title{margin:0;font-size:17px;font-weight:700;color:#1a1a1a;flex:1;}
            .sb-content{position:fixed;top:0;left:-110%;width:75vw;max-width:320px;height:100vh;background:#fff;z-index:600;overflow-y:auto;padding:20px 16px;box-shadow:4px 0 16px rgba(0,0,0,0.18);transition:left .3s ease;box-sizing:border-box;}
            .sb-content.isOpen{left:0;}
            .sb-close-btn{position:absolute;top:12px;right:12px;background:none;border:none;font-size:26px;cursor:pointer;color:#666;padding:4px;line-height:1;}
            .sb-acc-info{display:flex;align-items:center;justify-content:space-between;padding:40px 0 16px;}
            .acc-info{display:flex;align-items:center;gap:10px;flex:1;min-width:0;}
            .sb-leaderboard{display:flex;flex-direction:column;align-items:flex-end;gap:4px;flex-shrink:0;}
            .deposit-progress{height:4px;background:#f3f4f6;border-radius:2px;margin:8px 0;}
            .sb-menu.margin-top{margin-top:8px;}
            .common-menu{border-top:1px solid #f3f4f6;margin-top:16px;padding-top:8px;}
            .sb-content.isOpen::before{content:'';position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,0.4);z-index:-1;}

            /* ══ WALLET SECTION ══ */
            .member-wallet-links{display:flex;align-items:center;flex-wrap:wrap;gap:0;margin-bottom:6px;}
            .member-wallet-link{font-size:11px;color:#009bd8;cursor:pointer;white-space:nowrap;}
            .member-wallet-sep{color:#ddd;margin:0 5px;font-size:11px;}
            .wallet-balance-section{display:flex;align-items:center;justify-content:space-between;padding-bottom:10px;}
            .wallet-amount-container{display:flex;align-items:baseline;gap:6px;}
            .header-right{display:flex;align-items:flex-start;gap:4px;padding-top:2px;}
            .refresh-btn{background:none;border:none;cursor:pointer;padding:4px;display:flex;align-items:center;color:#009bd8;}
            .refresh-btn svg{width:18px!important;height:18px!important;display:block!important;max-width:18px!important;}
            .action-label{margin:0;font-size:11px;color:#374151;font-weight:500;text-align:center;white-space:nowrap;font-family:'Prompt','Noto Sans Thai',sans-serif;}
            .member-action:not(.bottom-content) .action-box svg{width:34px;height:34px;display:block;flex-shrink:0;overflow:visible;}
            .member-action.bottom-content{display:none;flex-wrap:wrap;gap:8px;padding:8px 0 12px;}
            .member-action.bottom-content.show{display:flex!important;}
            .member-action.bottom-content .action-box{width:60px;max-width:60px;}
            .member-action.bottom-content .action-box svg{width:44px;height:44px;display:block;flex-shrink:0;overflow:visible;}
            .message-container{position:relative;display:inline-flex;align-items:center;justify-content:center;width:44px;height:44px;}
            .message-container svg{width:44px;height:44px;display:block;}
            .unread-msg{position:absolute;top:-4px;right:-4px;background:#ef4444;color:#fff;font-size:9px;font-weight:700;border-radius:50%;width:16px;height:16px;display:flex;align-items:center;justify-content:center;margin:0;}
            .bk-rebate-page .collapse{display:flex!important;align-items:center;justify-content:center;gap:6px;padding:8px 0;cursor:pointer;font-size:13px;color:#009bd8;border-top:1px solid #f0f0f0;user-select:none;}
            .bk-rebate-page .collapse p{margin:0;font-size:13px;color:#009bd8;}
            .bk-rebate-page .collapse svg{width:8px!important;height:14px!important;pointer-events:none;}
            .slide-arrow .st0{fill:#009bd8;}

            /* ══ MENU CATEGORIES ══ */
            .menu-categories-container{position:fixed;top:0;left:0;right:0;bottom:0;z-index:500;display:flex;justify-content:flex-end;}
            .menu-overlay{position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.45);}
            .menu-account-container{position:relative;width:82vw;max-width:320px;height:100%;background:#fff;overflow-y:auto;box-shadow:-4px 0 20px rgba(0,0,0,0.18);display:flex;flex-direction:column;padding:16px 0 40px;box-sizing:border-box;}
            .menu-account-header{border-bottom:1px solid #f0f2f5;}
            .menu-account-header-title{display:flex;align-items:center;gap:12px;padding:14px 18px;cursor:pointer;user-select:none;}
            .mc-menu-svg{width:32px;height:32px;display:flex;align-items:center;justify-content:center;flex-shrink:0;}
            .menu-account-name{flex:1;font-size:14px;font-weight:600;color:#1a1a1a;font-family:'Prompt','Noto Sans Thai',sans-serif;}
            .dropdown-arrow{display:flex;align-items:center;transition:transform .2s;}
            .mc-arrow-open{transform:rotate(180deg);}
            .submenu-account{background:#f8fafc;border-top:1px solid #f0f2f5;}
            .submenu-account-header{padding:12px 18px 12px 62px;font-size:13px;color:#374151;cursor:pointer;font-family:'Prompt','Noto Sans Thai',sans-serif;border-bottom:1px solid #f3f4f6;}
            .submenu-account-header:last-child{border-bottom:none;}
            .mc-sub-active{color:#009bd8;font-weight:600;}
            .mc-badge{font-size:12px;color:#ef4444;font-weight:700;margin-left:4px;}

       
            /* ══ WALLET INFO ══ */
            .wallet-info{padding:14px 20px 12px;}
            .top-content{display:flex;align-items:stretch;justify-content:space-between;background:#ffffff;}
            .member-wallet{flex:1;min-width:0;background:#ffffff;display:flex;flex-direction:column;justify-content:space-between;}
            .header{display:flex;align-items:center;justify-content:space-between;}
            .header-left{display:flex;align-items:center;gap:6px;}
            .title{margin:0;font-size:14px;color:#374151;font-weight:500;font-family:'Prompt','Noto Sans Thai',sans-serif;}
            .eye-icon{width:18px;height:18px;display:inline-flex;align-items:center;justify-content:center;flex-shrink:0;overflow:hidden;}
            .eye-icon svg{width:18px!important;height:18px!important;display:block!important;max-width:18px!important;max-height:18px!important;}
            .bottom{display:flex;align-items:center;gap:8px;padding-top:10px;}
            .member-action:not(.bottom-content){display:flex;gap:4px;padding:0;flex-wrap:nowrap;align-items:stretch;margin-left:8px;}
            .member-action:not(.bottom-content) .action-box{display:flex;flex-direction:column;align-items:center;justify-content:space-between;cursor:pointer;width:56px;max-width:56px;overflow:hidden;padding:2px 0;}
            .member-action:not(.bottom-content) .action-label{margin:0;font-size:11px;color:#374151;font-weight:500;text-align:center;white-space:nowrap;font-family:'Prompt','Noto Sans Thai',sans-serif;}
            .currency-label{color:#8b98a5;font-size:13px;margin:0 4px 0 0;font-weight:500;font-family:'Prompt','Noto Sans Thai',sans-serif;}
            .member-balance{color:#006bd6;font-size:22px;font-weight:700;margin:0;letter-spacing:-0.3px;font-family:'Prompt','Noto Sans Thai',sans-serif;}
            ._drawerTrigger_19rt2_432{background:none;border:none;cursor:pointer;padding:0;display:flex;align-items:center;}
            ._mainWalletDetails_19rt2_186{margin:0;font-size:12px;color:#009bd8;font-weight:500;font-family:'Prompt','Noto Sans Thai',sans-serif;}
            .mobile-beta-refresh{cursor:pointer;display:block;width:20px;height:20px;flex-shrink:0;}
            @keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}

            /* ══ PERIOD TABS ══ */
            .rebate-period-tabs{display:flex;background:#fff;border-bottom:2px solid #f0f0f0;margin:0;}
            .rebate-period-tab{flex:1;padding:13px 0;text-align:center;font-size:14px;font-weight:600;color:#9ca3af;border:none;background:none;cursor:pointer;font-family:'Prompt','Noto Sans Thai',sans-serif;border-bottom:2px solid transparent;transition:all .2s;}
            .rebate-period-tab.active{color:#009bd8;border-bottom:2px solid #009bd8;}

            /* ══ SUMMARY CARD ══ */
            .rebate-summary-card{margin:12px 16px;background:linear-gradient(135deg,#095ebd 0%,#04a9c2 100%);border-radius:16px;padding:20px 18px;color:#fff;box-shadow:0 4px 18px rgba(9,94,189,0.25);}
            .rebate-summary-label{font-size:13px;opacity:0.85;margin:0 0 6px;font-weight:500;}
            .rebate-summary-amount{font-size:32px;font-weight:800;margin:0 0 16px;letter-spacing:-0.5px;}
            .rebate-summary-row{display:flex;justify-content:space-between;align-items:center;font-size:12px;opacity:0.85;}
            .rebate-claim-btn{background:#fff;color:#095ebd;border:none;border-radius:10px;padding:10px 24px;font-size:15px;font-weight:700;cursor:pointer;font-family:'Prompt','Noto Sans Thai',sans-serif;transition:opacity .15s;touch-action:manipulation;}
            .rebate-claim-btn:disabled{opacity:0.5;cursor:not-allowed;}

            /* ══ SECTION TITLE ══ */
            .rebate-section-title{margin:16px 16px 8px;font-size:14px;font-weight:700;color:#1a1a1a;}

            /* ══ RATE TABLE ══ */
            .rebate-rate-card{background:#fff;border-radius:12px;margin:0 16px 12px;box-shadow:0 1px 6px rgba(0,0,0,.07);overflow:hidden;}
            .rebate-rate-header{display:grid;grid-template-columns:1fr 1fr 1fr;background:#f8fafc;padding:10px 14px;border-bottom:1px solid #f0f0f0;}
            .rebate-rate-header span{font-size:12px;font-weight:600;color:#9ca3af;text-align:center;}
            .rebate-rate-header span:first-child{text-align:left;}
            .rebate-rate-row{display:grid;grid-template-columns:1fr 1fr 1fr;padding:13px 14px;border-bottom:1px solid #f8f9fa;align-items:center;}
            .rebate-rate-row:last-child{border-bottom:none;}
            .rebate-cat-cell{display:flex;align-items:center;gap:8px;}
            .rebate-cat-dot{width:8px;height:8px;border-radius:50%;flex-shrink:0;}
            .rebate-cat-name{font-size:13px;font-weight:600;color:#1a1a1a;}
            .rebate-rate-cell{text-align:center;font-size:13px;color:#374151;font-weight:500;}
            .rebate-rate-badge{display:inline-block;background:#e8f5e9;color:#16a34a;font-size:12px;font-weight:700;border-radius:20px;padding:2px 10px;}
            .rebate-amount-cell{text-align:right;font-size:13px;font-weight:700;color:#006bd6;}

            /* ══ INFO NOTICE ══ */
            .rebate-info-card{margin:0 16px 12px;background:#fff8ed;border:1.5px solid #fde68a;border-radius:12px;padding:12px 14px;}
            .rebate-info-row{display:flex;align-items:flex-start;gap:8px;margin-bottom:6px;}
            .rebate-info-row:last-child{margin-bottom:0;}
            .rebate-info-icon{font-size:14px;flex-shrink:0;margin-top:1px;}
            .rebate-info-text{font-size:12px;color:#92400e;line-height:1.5;}

            /* ══ HISTORY TABLE ══ */
            .rebate-history-card{background:#fff;border-radius:12px;margin:0 16px 12px;box-shadow:0 1px 6px rgba(0,0,0,.07);overflow:hidden;}
            .rebate-history-title{padding:12px 14px;font-size:13px;font-weight:700;color:#1a1a1a;border-bottom:1px solid #f3f4f6;}
            .rebate-history-table{width:100%;border-collapse:collapse;font-size:11px;}
            .rebate-history-table th{padding:8px;text-align:left;color:#9ca3af;font-weight:500;border-bottom:1px solid #f3f4f6;background:#fafafa;}
            .rebate-history-table td{padding:9px 8px;border-bottom:1px solid #f9fafb;color:#374151;}
            .rebate-history-table tr:last-child td{border-bottom:none;}
            .rebate-status-ok{color:#16a34a;font-weight:600;}
            .rebate-status-pending{color:#f59e0b;font-weight:600;}
            .rebate-history-empty{padding:28px;text-align:center;color:#9ca3af;font-size:12px;}

            /* ══ SECTION TABS ══ */
            .rebate-tab-bar{display:flex;background:#fff;margin:0 0 4px;border-bottom:1px solid #f0f0f0;}
            .rebate-tab-btn{flex:1;padding:13px 0;text-align:center;font-size:13px;font-weight:600;color:#9ca3af;border:none;background:none;cursor:pointer;font-family:'Prompt','Noto Sans Thai',sans-serif;border-bottom:3px solid transparent;transition:all .2s;}
            .rebate-tab-btn.active{color:#009bd8;border-bottom:3px solid #009bd8;}

            /* ══ CHAT BUTTON ══ */
            .bk-rebate-chat-btn{position:fixed;bottom:76px;right:16px;z-index:300;width:48px;height:48px;border-radius:50%;background:linear-gradient(135deg,#ff8a00,#ff5500);display:flex;align-items:center;justify-content:center;box-shadow:0 4px 14px rgba(255,138,0,.45);cursor:pointer;border:none;text-decoration:none;}

            /* ══ ANIMATIONS ══ */
            @keyframes bk-spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}
            .bk-spinning{animation:bk-spin 1s linear infinite;}

            /* ══ SWEETALERT2 COMPACT ══ */
            .swal2-popup{width:300px !important;padding:1.2em 1.4em !important;font-family:'Prompt','Noto Sans Thai',sans-serif !important;}
            .swal2-title{font-size:1.1em !important;padding:0.4em 0 0 !important;}
            .swal2-html-container{font-size:0.85em !important;margin:0.4em 0 0 !important;}
            .swal2-icon{width:56px !important;height:56px !important;margin:0.6em auto 0.4em !important;}
            .swal2-icon .swal2-icon-content{font-size:2em !important;}
            .swal2-actions{margin:0.8em 0 0 !important;gap:8px !important;}
            .swal2-confirm,.swal2-cancel{font-size:0.9em !important;padding:0.55em 1.6em !important;border-radius:8px !important;}
        `;

        const displayRates = rebateList.length > 0 ? rebateList : defaultRebateRates;

        return (
            <>
                <style dangerouslySetInnerHTML={{ __html: bkCss }} />
                <div className="bk-rebate-page">

                    {/* ══ Mobile Navbar Header ══ */}
                    <header id="mobile-navbar-header" className="mobile-navbar-header">
                        <nav className="mobile-nav header-grey">
                            <div className="col-left">
                                {/* Beta-back arrow */}
                                <button
                                    type="button"
                                    onClick={() => this.props.navigate('/')}
                                    style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center' }}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                        viewBox="0 0 22.67717 22.67717"
                                        className="menu-icon beta-back"
                                        width="22" height="22"
                                    >
                                        <style dangerouslySetInnerHTML={{ __html: ".beta-back .st0{fill:url(#rebate-beta-back-SVGID_1_);}" }} />
                                        <g className="beta-back">
                                            <linearGradient id="rebate-beta-back-SVGID_1_" gradientUnits="userSpaceOnUse" x1="9.094947e-13" y1="11.33858" x2="22.67717" y2="11.33858">
                                                <stop offset="0" style={{ stopColor: "rgb(9,94,189)" }} />
                                                <stop offset="1" style={{ stopColor: "rgb(4,169,194)" }} />
                                            </linearGradient>
                                            <path className="st0" d="M0.3228,12.12548l5.56403,5.54451c0.4294,0.4299,1.12705,0.4299,1.55644,0c0.4304-0.4299,0.4304-1.12705,0-1.55694l-3.68425-3.66523h17.81665c0.60825,0,1.10149-0.49279,1.10149-1.10104c0-0.60825-0.49324-1.10103-1.10149-1.10103H3.75903l3.70018-3.68171c0.4304-0.4299,0.4304-1.12659,0-1.55694C7.24404,4.79186,6.963,4.68475,6.68096,4.68475c-0.28199,0-0.56403,0.10711-0.7782,0.32234L0.3228,10.56803C-0.1076,10.99843-0.1076,11.69513,0.3228,12.12548z" />
                                        </g>
                                    </svg>
                                </button>

                                <p className="page-title">เงินคืนทันที</p>

                                {/* Sidebar drawer */}
                                <div className={`sb-content ${isGuideOpen ? "isOpen" : ""}`}>
                                    <button
                                        type="button"
                                        className="sb-close-btn"
                                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ isGuideOpen: false }); }}
                                    >×</button>
                                    <div className="content-container content-1">
                                        <div className="sb-acc-info">
                                            <div className="acc-info">
                                                <div style={{ width: 32, height: 32, borderRadius: '50%', background: '#f7931a', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 32 32" fill="white">
                                                        <path d="M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0zm3.7 14.2c.3-2-1.2-3.1-3.3-3.8l.7-2.7-1.7-.4-.7 2.6-1.3-.3.7-2.6-1.7-.4-.7 2.7-1.1-.3-2.3-.6-.4 1.8s1.2.3 1.2.3c.7.2.8.7.8 1l-.8 3.3c.1 0 .1 0 .2.1l-.2-.1-1.2 4.7c-.1.2-.3.5-.8.4 0 0-1.2-.3-1.2-.3l-.8 2 2.2.5 1.2.3-.7 2.7 1.7.4.7-2.7 1.3.3-.7 2.7 1.7.4.7-2.7c2.8.5 4.9.3 5.8-2.2.7-2-.1-3.1-1.5-3.9 1.1-.3 1.9-1 2.1-2.5zm-3.7 5.2c-.5 2-3.9 1-5 .7l.9-3.5c1.1.3 4.6.9 4.1 2.8zm.5-5.3c-.5 1.8-3.3 1-4.2.7l.8-3.2c.9.2 3.9.7 3.4 2.5z" />
                                                    </svg>
                                                </div>
                                                <div className="info-content" style={{ marginLeft: 10 }}>
                                                    <p className="welcome-title" style={{ margin: 0, fontSize: 11, color: '#9ca3af' }}>ยินดีต้อนรับ</p>
                                                    <p className="acc-name" style={{ margin: 0, fontSize: 14, fontWeight: 700, color: '#1a1a1a' }}>{username || '-'}</p>
                                                </div>
                                            </div>
                                            <div className="sb-leaderboard" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                                <span style={{ fontSize: 11, background: '#e8f0fe', color: '#1a73e8', borderRadius: 20, padding: '2px 10px', fontWeight: 600 }}>{rankname || 'Normal'}</span>
                                                <span style={{ fontSize: 11, color: '#f59e0b', fontWeight: 600 }}>👑 {rankpoint || 0}</span>
                                            </div>
                                        </div>
                                        <div className="sb-menu margin-top">
                                            {[
                                                { label: 'สปอนเซอร์', href: '/' },
                                                { label: 'VIP', href: '/' },
                                                { label: 'ลีดเดอร์บอร์ด', href: '/' },
                                                { label: 'ดาวน์โหลด', href: '/' },
                                            ].map(item => (
                                                <a key={item.label} href={item.href} className="menu" style={{ display: 'flex', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid #f3f4f6', textDecoration: 'none', color: '#374151', fontSize: 14 }}>
                                                    <span>{item.label}</span>
                                                </a>
                                            ))}
                                        </div>
                                        <div className="common-menu">
                                            {[
                                                { label: 'หน้าแรก', href: '/' },
                                                { label: 'ฝากเงิน', href: '/deposit' },
                                                { label: 'ถอนเงิน', href: '/withdraw' },
                                                { label: 'โปรโมชั่น', href: '/' },
                                                { label: 'กีฬา', href: '/' },
                                                { label: 'คาสิโนสด', href: '/' },
                                                { label: 'สล็อต', href: '/' },
                                            ].map(item => (
                                                <a key={item.label} href={item.href} className="common-menu-item" style={{ display: 'block', padding: '10px 0', borderBottom: '1px solid #f3f4f6', textDecoration: 'none', color: '#374151', fontSize: 14 }}>
                                                    {item.label}
                                                </a>
                                            ))}
                                        </div>
                                        <button
                                            type="button"
                                            style={{ width: '100%', marginTop: 16, padding: '10px 0', background: 'none', border: '1px solid #e5e7eb', borderRadius: 8, color: '#ef4444', fontWeight: 600, cursor: 'pointer', fontSize: 14, fontFamily: 'inherit' }}
                                            onClick={() => { localStorage.clear(); window.location.href = '/'; }}
                                        >ออกจากระบบ</button>
                                    </div>
                                </div>
                            </div>

                            <div className="col-right">
                                {/* 3-dots menu */}
                                <button
                                    type="button"
                                    style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '8px 4px', display: 'flex', alignItems: 'center' }}
                                    onClick={() => this.setState({ isMenuOpen: true, menuOpenIndex: 0 })}
                                >
                                    <svg width={27} height={5} viewBox="0 0 27 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#rebate-dots-clip)">
                                            <path d="M2.09305 4.66102C3.24901 4.66102 4.1861 3.72393 4.1861 2.56797C4.1861 1.41201 3.24901 0.474915 2.09305 0.474915C0.937091 0.474915 0 1.41201 0 2.56797C0 3.72393 0.937091 4.66102 2.09305 4.66102Z" fill="#8697A2" />
                                            <path d="M13.25 4.66102C14.406 4.66102 15.3431 3.72393 15.3431 2.56797C15.3431 1.41201 14.406 0.474915 13.25 0.474915C12.094 0.474915 11.157 1.41201 11.157 2.56797C11.157 3.72393 12.094 4.66102 13.25 4.66102Z" fill="#8697A2" />
                                            <path d="M24.407 4.66102C25.5629 4.66102 26.5 3.72393 26.5 2.56797C26.5 1.41201 25.5629 0.474915 24.407 0.474915C23.251 0.474915 22.3139 1.41201 22.3139 2.56797C22.3139 3.72393 23.251 4.66102 24.407 4.66102Z" fill="#8697A2" />
                                        </g>
                                        <defs>
                                            <clipPath id="rebate-dots-clip">
                                                <rect width="26.5" height="4.19509" fill="white" transform="translate(0 0.474915)" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </button>
                            </div>
                        </nav>
                    </header>

                    {/* ══ Menu Categories Container (3-dots) ══ */}
                    {isMenuOpen && (
                        <div className="menu-categories-container">
                            <div className="menu-overlay" onClick={() => this.setState({ isMenuOpen: false })} />
                            <section className="menu-account-container">
                                {[
                                    { label: 'แคชเชียร์', items: [{ label: 'ฝากเงิน', href: '/deposit' }, { label: 'ถอน', href: '/withdraw' }, { label: 'รายละเอียดการถอนเงิน', href: '/withdraw' }] },
                                    { label: 'รางวัล', items: [{ label: 'เงินคืนทันที', href: '/rebate', active: true }, { label: 'งานประจำวัน', href: '/', badge: '1' }, { label: 'แนะนำเพื่อน', href: '/' }] },
                                    { label: 'โปรไฟล์ของฉัน', items: [{ label: 'บัญชีของฉัน', href: '/profile' }, { label: 'ข้อความ', href: '/profile' }, { label: 'เปลี่ยนรหัสผ่าน', href: '/profile' }] },
                                    { label: 'ประวัติ', items: [{ label: 'ประวัติการโอนเงิน', href: '/statement' }] },
                                ].map((menu, idx) => (
                                    <div className="menu-account-header" key={idx}>
                                        <div className="menu-account-header-title" onClick={() => this.setState({ menuOpenIndex: menuOpenIndex === idx ? -1 : idx })}>
                                            <div className="mc-menu-svg" style={{ width: 32, height: 32, background: '#f0f4ff', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="#095EBD" viewBox="0 0 16 16"><circle cx="8" cy="8" r="7" stroke="#095EBD" strokeWidth="1.5" fill="none" /><path d="M8 4v4l3 2" stroke="#095EBD" strokeWidth="1.5" strokeLinecap="round" fill="none" /></svg>
                                            </div>
                                            <span className="menu-account-name">{menu.label}</span>
                                            <div className={`dropdown-arrow${menuOpenIndex === idx ? ' mc-arrow-open' : ''}`}>
                                                <svg width="17" height="17" viewBox="0 0 17 17" fill="none"><path d="M14.5444 7.10467C14.5444 7.38307 14.4409 7.66252 14.235 7.87536L9.56017 12.7069C9.30038 12.9766 8.95498 13.1228 8.5885 13.1228C8.22093 13.1228 7.87662 12.9744 7.6178 12.7058L2.94304 7.87536C2.53005 7.44963 2.53005 6.75865 2.94304 6.33181C3.35604 5.90502 4.02568 5.90502 4.43759 6.33181L8.5885 10.6219L12.7394 6.33181C13.1523 5.90502 13.821 5.90502 14.235 6.33181C14.4409 6.5447 14.5444 6.82415 14.5444 7.10467Z" fill="#61757E" /></svg>
                                            </div>
                                        </div>
                                        {menuOpenIndex === idx && (
                                            <div className="submenu-account">
                                                {menu.items.map((item, ii) => (
                                                    <div key={ii} className={`submenu-account-header${item.active ? ' mc-sub-active' : ''}`} onClick={() => { window.location.href = item.href; }}>
                                                        <span>{item.label}{item.badge && <span className="mc-badge">({item.badge})</span>}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </section>
                        </div>
                    )}

                    {/* ══ User Top Bar ══ */}
                    <MobileUserBar loginstate={loginstate} username={username} rankname={rankname} rankpoint={rankpoint} />

                    {/* ══ Wallet Section ══ */}
                    <MobileWalletSection
                        loginstate={loginstate}
                        balance={balance}
                        checkcredit={this.state.checkcredit}
                        showMemberAction={showMemberAction}
                        onRefresh={(e) => this.recheccredit(e)}
                        onToggleMemberAction={() => this.setState({ showMemberAction: !this.state.showMemberAction })}
                        onDeposit={() => this.props.navigate('/deposit')}
                        onWithdraw={() => this.props.navigate('/withdraw')}
                        onStatement={() => this.props.navigate('/statement')}
                        onMessage={() => window.location.href = '/manager/message'}
                    />

                    {/* ══ Section Tabs: เงินคืน / ประวัติ ══ */}
                    <div className="rebate-tab-bar">
                        <button
                            type="button"
                            className={`rebate-tab-btn${tabRebate === 0 ? ' active' : ''}`}
                            onClick={() => this.setState({ tabRebate: 0 })}
                        >เงินคืน</button>
                        <button
                            type="button"
                            className={`rebate-tab-btn${tabRebate === 1 ? ' active' : ''}`}
                            onClick={() => this.setState({ tabRebate: 1 })}
                        >ประวัติการรับเงินคืน</button>
                    </div>

                    {/* ══ TAB 0: เงินคืน ══ */}
                    {tabRebate === 0 && (
                        <>
                            {/* Period Selector */}
                            <div className="rebate-period-tabs">
                                <button
                                    type="button"
                                    className={`rebate-period-tab${rebatePeriod === 'daily' ? ' active' : ''}`}
                                    onClick={() => this.setState({ rebatePeriod: 'daily' })}
                                >รายวัน</button>
                                <button
                                    type="button"
                                    className={`rebate-period-tab${rebatePeriod === 'weekly' ? ' active' : ''}`}
                                    onClick={() => this.setState({ rebatePeriod: 'weekly' })}
                                >รายสัปดาห์</button>
                            </div>

                            {/* Summary Card */}
                            <div className="rebate-summary-card">
                                <p className="rebate-summary-label">ยอดเงินคืนของคุณ</p>
                                <p className="rebate-summary-amount">
                                    THB {parseFloat(rebateTotalAmount || 0).toFixed(2)}
                                </p>
                                <div className="rebate-summary-row">
                                    <span style={{ fontSize: 12, opacity: 0.85 }}>
                                        {rebatePeriod === 'daily' ? 'คำนวณเที่ยงคืนทุกวัน' : 'คำนวณทุกวันจันทร์ 00:00'}
                                    </span>
                                    <button
                                        type="button"
                                        className="rebate-claim-btn"
                                        disabled={claimLoading || parseFloat(rebateTotalAmount || 0) <= 0}
                                        onClick={this.claimRebate}
                                    >
                                        {claimLoading ? 'กำลังดำเนินการ...' : 'รับเงินคืน'}
                                    </button>
                                </div>
                            </div>

                            {/* Rate Table */}
                            <p className="rebate-section-title">อัตราเงินคืน</p>
                            <div className="rebate-rate-card">
                                <div className="rebate-rate-header">
                                    <span>ประเภทเกม</span>
                                    <span>ยอดเดิมพัน</span>
                                    <span style={{ textAlign: 'right' }}>เงินคืน</span>
                                </div>
                                {displayRates.map((item, i) => (
                                    <div className="rebate-rate-row" key={i}>
                                        <div className="rebate-cat-cell">
                                            <span className="rebate-cat-dot" style={{ background: item.color || '#009bd8' }}></span>
                                            <span className="rebate-cat-name">{item.category}</span>
                                        </div>
                                        <div className="rebate-rate-cell">
                                            {item.turnover != null
                                                ? `THB ${parseFloat(item.turnover).toFixed(2)}`
                                                : 'THB 0.00'}
                                        </div>
                                        <div className="rebate-amount-cell">
                                            <span className="rebate-rate-badge">
                                                {item.rebateRate || item.rate || '0.5%'}
                                            </span>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Info Notice */}
                            <div className="rebate-info-card">
                                <div className="rebate-info-row">
                                    <span className="rebate-info-icon">ℹ</span>
                                    <span className="rebate-info-text">เงินคืนจะถูกคำนวณจากยอดเดิมพันสุทธิของคุณในแต่ละประเภทเกม</span>
                                </div>
                                <div className="rebate-info-row">
                                    <span className="rebate-info-icon">⏰</span>
                                    <span className="rebate-info-text">สามารถกดรับเงินคืนได้ทันทีโดยไม่มีเงื่อนไขการเทิร์น</span>
                                </div>
                                <div className="rebate-info-row">
                                    <span className="rebate-info-icon">💰</span>
                                    <span className="rebate-info-text">ยอดเงินคืนขั้นต่ำในการรับ: THB 1.00</span>
                                </div>
                                <div className="rebate-info-row">
                                    <span className="rebate-info-icon">📅</span>
                                    <span className="rebate-info-text">รายวัน: รับได้ทุกวันหลังเที่ยงคืน | รายสัปดาห์: รับได้ทุกวันจันทร์</span>
                                </div>
                            </div>
                        </>
                    )}

                    {/* ══ TAB 1: ประวัติ ══ */}
                    {tabRebate === 1 && (
                        <div className="rebate-history-card" style={{ margin: '12px 16px' }}>
                            <div className="rebate-history-title">ประวัติการรับเงินคืน</div>
                            {(!rebateHistory || rebateHistory.length === 0) ? (
                                <div className="rebate-history-empty">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#d1d5db" width="40" height="40" style={{ display: 'block', margin: '0 auto 8px' }}>
                                        <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 14H7v-2h5v2zm5-4H7v-2h10v2zm0-4H7V7h10v2z" />
                                    </svg>
                                    ยังไม่มีประวัติการรับเงินคืน
                                </div>
                            ) : (
                                <table className="rebate-history-table">
                                    <thead>
                                        <tr>
                                            <th>วันที่</th>
                                            <th>ประเภท</th>
                                            <th>จำนวน</th>
                                            <th>สถานะ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rebateHistory.slice(0, 10).map((item, i) => (
                                            <tr key={i}>
                                                <td>{item.createdate ? new Date(item.createdate).toLocaleDateString('th-TH', { day: '2-digit', month: '2-digit', year: '2-digit' }) : '-'}</td>
                                                <td>{item.period === 'weekly' ? 'รายสัปดาห์' : 'รายวัน'}</td>
                                                <td style={{ fontWeight: 700, color: '#16a34a' }}>+{parseFloat(item.amount || 0).toFixed(2)}</td>
                                                <td>
                                                    <span className={item.status === '1' || item.status === 1 ? 'rebate-status-ok' : 'rebate-status-pending'}>
                                                        {item.status === '1' || item.status === 1 ? 'สำเร็จ' : 'รอดำเนินการ'}
                                                    </span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    )}

                    {/* ══ Floating Line Chat ══ */}
                    {linelink && (
                        <a href={`https://line.me/ti/p/${linelink}`} target="_blank" rel="noreferrer" className="bk-rebate-chat-btn">
                            <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} fill="#fff" viewBox="0 0 16 16">
                                <path d="M16 8c0 3.866-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7zM4.5 5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm-.5 2.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 0-1h-5a.5.5 0 0 0-.5.5zm.5 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3z" />
                            </svg>
                        </a>
                    )}

                    {/* ══ Bottom Navbar ══ */}
                    <Navmenu />

                </div>
            </>
        );
    }

    render() {
        if (isMobile || (typeof window !== 'undefined' && window.innerWidth <= 768)) return this.renderMobile();

        // Desktop fallback — redirect to mobile layout
        return this.renderMobile();
    }
}

export default withRouter(App);
